<template>
  <el-card class="box-card">
    <div slot="header" class="cardheader">
      <div>{{ $t('lang.loginPage.login') }}</div>
    </div>
    <div class="request-body">
      <div>
        <el-button size="mini" style="width: 100%" type="ceibsprimary" @click="openSsoPage">
          {{ $t('lang.loginPage.useCeibsAccount') }}
        </el-button>
      </div>
      <div>
        <el-button size="mini" style="width: 100%; margin-top: 20px;" type="ceibsprimary" @click="quickApply">
          {{ $t('lang.loginPage.quickApply') }}
        </el-button>
      </div>
      <el-divider></el-divider>
      <div>
        <el-button size="mini" style="width: 100%;" type="ceibsprimary" @click="goto('/quickQuery')">
          {{ $t('lang.loginPage.applyQuery') }}
        </el-button>
      </div>
    </div>
    <el-link type="info" style="margin-top: 10px;" v-if="noticeContent" @click="showNoticeDialog">
      {{ $t('lang.loginPage.systemNotice') }}
    </el-link>
    <el-dialog
      custom-class="ceibsdialog"
      width="800px"
      :visible.sync="noticeDialogVisible"
      :center="true">
      <div slot="title" style="color: #a2100e;">{{ $t('lang.loginPage.systemNotice') }}</div>
      <div v-html="noticeContent"></div>
    </el-dialog>
  </el-card>
</template>

<script>
import { findNotice, getAuthorizationUrl } from '@/api/base'
import { removeToken } from '@/util/util.ruquest'
import { quickQuery } from '@/api/apply'
import { mapGetters } from 'vuex'

export default {
  name: 'NotLoginCard',
  data () {
    return {
      noticeContent: null,
      authorizationUrl: null,
      noticeDialogVisible: false,
      searchForm: {
        idNo: '',
        applyNo: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentApplyId'
    ])
  },
  mounted () {
    this.loadNotice()
  },
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    openSsoPage () {
      this.$store.dispatch('removeCurrentApplyId')
      this.$store.dispatch('removeQuickApplyId')
      getAuthorizationUrl().then(res => {
        window.location.href = res.data
      })
    },
    quickApply () {
      this.$store.dispatch('removeCurrentApplyId')
      removeToken()
      this.goto('confirmInfo')
    },
    query () {
      removeToken()
      if (this.searchForm.idNo === '' || this.searchForm.applyNo === '') {
        return
      }
      quickQuery(this.searchForm).then(res => {
        this.$store.dispatch('setQuickQueryApplyId', res.data.id)
        this.$router.push('/applyList')
      })
    },
    showNoticeDialog () {
      this.noticeDialogVisible = !this.noticeDialogVisible
    },
    loadNotice () {
      findNotice().then(res => {
        if (res.data) {
          this.noticeContent = res.data.content
          this.noticeDialogVisible = true
        }
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  background-color: unset;
  border-radius: 8px;
  border: none;
  box-shadow: 3px 7px 12px 1px rgb(0 0 0 / 45%);
}

.cardheader {
  background: linear-gradient(to left, #a2100e, rgba(162, 16, 14, 0.5));
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 25px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  text-shadow: 2px 2px 5px rgb(8 8 8 / 19%);
  text-align: center;
}

.request-body {
  text-align: center;
}

.card-tip {
  font-size: 14px;
  color: rgba(86, 86, 86, 0.63);
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
}

/deep/ .el-input__inner {
  background-color: #c5c5c5;
  border-radius: 0;
  height: 34px;
  line-height: 34px;
  margin-bottom: 5px;
  text-align: center;
}

/deep/ .el-input__inner::placeholder {
  color: #565656;
}

/deep/ .el-card__header {
  padding: 0;
}

/deep/ .el-card__body {
  background-color: rgba(255, 255, 255, 0.85);
  /*height: 160px;*/
}
</style>
